import { collection } from '../jsonEditor/collectionJsonEditorConfig.js';
import { versionConfig, regionConfig, languageConfig } from '../options.js';
export const collections = {
    type: 'collections',
    contentType: 'collection',
    editor: 'json',
    editorConfig: collection,
    editorContext: 'content',
    title: 'Collection',
    plural: 'Collections',
    endpoint: 'collections',
    supportContent: [],
    version: versionConfig,
    listing: {
        type: 'grid',
        gridColumns: ['slug', 'type', 'client'],
        gridContentType: 'collections',
        gridCombineProperty: 'slug',
        gridDecode: ['title'],
        gridFilters: [],
        gridHasChildren: true,
        gridJoin: { properties: ['tags', 'categories'] },
        gridSearch: [{ key: 'slug', combine: true }],
        gridSupportContent: [],
    },
    queryProperties: ['id', 'slug', 'status', 'type', 'client', 'region', 'language', 'created'],
    sidebar: {
        status: [
            {
                label: 'Status',
                name: 'status',
                input: 'select',
                options: [
                    { label: 'Draft', value: 'draft' },
                    { label: 'Pending', value: 'pending' },
                    { label: 'Publish', value: 'published' },
                ],
            },
            {
                label: 'Created',
                name: 'created',
                input: 'datetime-local',
            },
        ],
        version: [
            { label: 'Slug', name: 'slug', input: 'text' },
            { label: 'Client', name: 'client', input: 'multiselect' },
            regionConfig,
            languageConfig,
        ],
    },
    meta: [
        {
            label: 'Exclude Client',
            name: 'exclude',
            input: 'multiselect',
            description: 'Add clients to prevent them from viewing this article.',
        },
    ],
    validate: [],
};
//# sourceMappingURL=collections.js.map